import actions from '../../actionTypes';

export default data => {
  return {
    type: actions.SET_AP_DETAIL,
    accessPointData: data
  };
};



// WEBPACK FOOTER //
// ./src/reducers/status/actions/setApDetail.js